$(function() {
    let nav = $('nav#header');
    let background = $('#background_menu_open');

    nav.on('shown.bs.dropdown', function() {
        background.fadeIn('fast');
    });

    nav.on('hide.bs.dropdown', function() {
        background.fadeOut('fast');
    });

    $('#navbar-mobile').on('shown.bs.collapse', function () {
        $('body').css('overflow', 'hidden');
    })

    $('.navbar').on('hidden.bs.collapse', function () {
        $('body').css('overflow', '');
    })

    // $('#nav-search').click(function() {
    //     $('#menu-menu-header').slideUp('fast');
    // })
});